export const QueryParamNames = {
  Property: 'property',
  /** Active Pages tab — set by direct tab clicks and the KPI-card CTAs. */
  Tab: 'tab',
  /** Pages URL-contains search text — typed in the toolbar, or set by Performance by path's Review. */
  Search: 'search',
} as const;

type QueryParamName = typeof QueryParamNames[keyof typeof QueryParamNames];

const QueryParamNamesList = Object.values(QueryParamNames);

export type SearchPerformanceQueryParams = Partial<{
  property: string;
  tab: string;
  search: string;
}>;

function isSearchPerformanceParam(name: string): name is QueryParamName {
  return QueryParamNamesList.includes(name as QueryParamName);
}

export function buildSearchPerformanceQueryParameters(
  data: Record<string, string>
): SearchPerformanceQueryParams {
  return Object.entries(data).reduce<SearchPerformanceQueryParams>((acc, [name, value]) => {
    if (!isSearchPerformanceParam(name)) return acc;

    acc[name] = value;

    return acc;
  }, {});
}
